import React from 'react';
import useAccessibleClick from "../../../common/hooks/useAccessibleClick";
import styles from './SelectOption.module.scss';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import cx from 'classnames';

const SelectItem = ({
  option,
  index,
  handleSelect,
  selectedIcon,
  unselectedIcon,
  isMultiple,
  currentlySelected,
  className,
  placeholder
}) => {
  const myRef = useAccessibleClick(handleSelect);

  const { t } = useTranslation();

  return (
    <li tabIndex={0} ref={myRef} role="button" className={styles.option} key={option?.id ? option?.id : option?.name || option?.title} onClickCapture={handleSelect}>
      <div className={cx(styles.listItemContainer, className)}>
        {option.isImage ? (
          <div className={styles.selectImageContainer}>
            <img src={placeholder} className={styles.selectImage} alt={t('accessibility.placeholder_logo')} />
            <div
              className={cx(styles.selectImageLetter, {
                [styles.backgroundStyle]: index === 0,
                [styles.shadowStyle]: index === 1,
                [styles.borderStyle]: index === 2,
              })}
            >
              {'A'}
            </div>
          </div>
        ) : null}
        {selectedIcon &&
          (isMultiple ? currentlySelected?.some(({ id }) => id === option?.id) : option?.id === currentlySelected?.id) && (
            <Icon src={selectedIcon} className={styles.checkedIcon} />
          )}
        {unselectedIcon &&
          (isMultiple ? !currentlySelected?.some(({ id }) => id === option?.id) : option?.id !== currentlySelected?.id) && (
            <Icon src={unselectedIcon} className={styles.checkedIcon} />
          )}
        {option?.name?.startsWith('#') && <div className={styles.colorExample} style={{ background: option?.name }}></div>}
        <span className={cx({ [styles.marginLeft]: selectedIcon && !unselectedIcon && option?.id !== currentlySelected?.id, [styles.withDescription]: option?.description })} style={{ '--after-content': `"${t(option?.description)}"` }}>
          {t(option?.key || option?.name || option?.title)}
        </span>
      </div>
    </li>
  )
}

export default SelectItem;